var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "container-fluid p-0 m-0" }, [
    _c(
      "div",
      {
        staticClass: "carousel slide p-0 m-0",
        attrs: { id: "myCarousel", "data-bs-ride": "carousel" },
      },
      [
        _c(
          "div",
          {
            staticClass: "carousel-inner p-0 m-0 mb-1",
            staticStyle: { "margin-bottom": "1em" },
            attrs: { role: "listbox" },
          },
          _vm._l(_vm.JournalsData, function (jd) {
            return _c(
              "div",
              {
                key: jd.slide_number,
                staticClass: "carousel-item",
                class: { item: true, active: _vm.isActive(jd.slide_number) },
              },
              [_c("journal-vue-slide", { attrs: { JournalData: jd } })],
              1
            )
          }),
          0
        ),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "button",
      {
        staticClass: "carousel-control-prev",
        attrs: {
          type: "button",
          "data-bs-target": "#myCarousel",
          "data-bs-slide": "prev",
        },
      },
      [
        _c("span", {
          staticClass: "carousel-control-prev-icon",
          attrs: { "aria-hidden": "true" },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "visually-hidden" }, [_vm._v("Previous")]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "button",
      {
        staticClass: "carousel-control-next",
        attrs: {
          type: "button",
          "data-bs-target": "#myCarousel",
          "data-bs-slide": "next",
        },
      },
      [
        _c("span", {
          staticClass: "carousel-control-next-icon",
          attrs: { "aria-hidden": "true" },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "visually-hidden" }, [_vm._v("Next")]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }